import apiFetch from '../apiFetch'

export default function (token, campaignCode, dossierId) {
  return apiFetch({ endPoint: `Campaign/${dossierId}/GetCampaignCode`, method: 'PUT', token: token, body: campaignCode })
}
